// Règles et sécurité : ce que la carte ne fait pas, et ce que la loi demande. Repris au premier lancement.
import './rules.css';

export function WhatItIsNot() {
  return (
    <div className="regle regle-securite" role="note">
      <p className="regle-titre">Cette carte n'identifie aucun champignon</p>
      <p>
        Elle dit où et quand la pousse est probable, jamais si un champignon se mange. Pour toute détermination, montrez votre récolte
        à un pharmacien ou à une association mycologique, comme l'Association mycologique de Bigorre.
      </p>
    </div>
  );
}

export function RulesList() {
  return (
    <ul className="regles">
      <li>
        <span className="regle-motif regle-motif-interdit" aria-hidden="true" />
        <span>
          <strong>Cœur du Parc national, hachuré en rouge :</strong> ni cueillette ni prélèvement, quelle que soit la quantité.
        </span>
      </li>
      <li>
        <span className="regle-motif" aria-hidden="true" />
        <span>
          <strong>Forêt privée :</strong> les champignons appartiennent au propriétaire. Demandez son accord ; au-delà de 10 litres sans
          autorisation, c'est un délit.
        </span>
      </li>
      <li>
        <span className="regle-motif" aria-hidden="true" />
        <span>
          <strong>Forêt publique :</strong> cueillette familiale tolérée, dans les limites de l'arrêté préfectoral ou municipal, qui varie
          d'une commune à l'autre. Renseignez-vous en mairie.
        </span>
      </li>
      <li>
        <span className="regle-motif" aria-hidden="true" />
        <span>
          <strong>Sur place :</strong> ne ratissez pas le sol, laissez les petits, et méfiez-vous des jours de battue en période de chasse.
        </span>
      </li>
    </ul>
  );
}
